import { Box } from "@mui/material";
import { CircularIconButton, UpArrow2Icon } from "components";
import { type RefObject, useEffect, useState } from "react";
import { PRICING_DESIGN_VALUES } from "./pricingDesignValues";

interface ScrollDownButtonProps {
  targetRef: RefObject<HTMLElement>;
}

// PH-5 · TODO: behaviour not designed. Scrolls to the AI section and hides
// once it is on screen. PH-4 · TODO: aria-label copy not supplied —
// CircularIconButton falls back to its default label until a `tooltip` is set.
export const ScrollDownButton = ({ targetRef }: ScrollDownButtonProps) => {
  const [isTargetVisible, setIsTargetVisible] = useState(false);

  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;
    const observer = new IntersectionObserver(([entry]) => {
      setIsTargetVisible(entry.isIntersecting);
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [targetRef]);

  if (isTargetVisible) return null;

  return (
    // Zero-height sticky row: pins the button to the bottom-right of the
    // scrolling panel without taking up layout space.
    <Box
      sx={{
        position: "sticky",
        bottom: PRICING_DESIGN_VALUES.scrollButton.bottom,
        zIndex: 2,
        height: 0,
        display: "flex",
        justifyContent: "flex-end",
        paddingRight: PRICING_DESIGN_VALUES.scrollButton.right,
      }}
    >
      <CircularIconButton
        size="small"
        icon={
          <UpArrow2Icon fontSize="small" sx={{ transform: "rotate(180deg)" }} />
        }
        onClick={() =>
          targetRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          })
        }
        sx={{ transform: "translateY(-100%)" }}
      />
    </Box>
  );
};
